module.exports = __webpack_public_path__ + "static/014-0646e8539ca07f9fcdf1d5cf260be6b4.png";